import { inject, Injectable } from '@angular/core';
import { BASE_URL_TOKEN } from '../../../core/injection-tokens/base-url.token';
import { FilterApiService } from '../filterApi/filter-api.service';
import { HttpClient } from '@angular/common/http';
import { IFilter, INotification, IPagingResponse } from '../../../core/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService {
  private baseUrl = inject(BASE_URL_TOKEN);
  private filter = inject(FilterApiService);
  private path = 'notifications';
  private http = inject(HttpClient);
  /**
   * @param  {IFilter} filter
   * @returns Observable
   */
  getFilteredNotifications(filter: IFilter): Observable<IPagingResponse<INotification[]>> {
    return this.filter.getFilteredData(`${this.baseUrl}/${this.path}/getNotifications`, filter)
  }

  markNotificationAsRead(id: string) {
    return this.http.post(`${this.baseUrl}/${this.path}/markAsRead/${id}`, null)
  }

  markAllNotificationsAsRead() {
    return this.http.post(`${this.baseUrl}/${this.path}/markAllAsRead`, null)
  }

}
